import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {DesignServiceModel} from "../models/domain/designServiceModel";
import {setDesignService} from "../redux/slices/addToCart";
import {useAppDispatch, useDesignServiceId} from "../redux/stateHooks";

export const useDesignServiceQuery = () => {
    const {model: {designService}} = useProductDetailsQuery();
    const dispatch = useAppDispatch();
    const designServiceId = useDesignServiceId();

    const {id} = designService ?? {};

    return {
        model: designService ? new DesignServiceModel(designService) : {
            id: undefined,
            formatted: {price: undefined},
            price: undefined,
        },
        checked: designServiceId == id,
        onChange: () => dispatch(setDesignService(designServiceId === id ? undefined : id))
    };
}